<template>
  <b-form-group
    label="Miktar"
    label-for="amount"
  >
    <validation-provider
      #default="{ errors }"
      name="Miktar"
      rules="required"
    >
      <b-input-group :append="dataItem[iKey].units">
        <b-form-input
          id="amount"
          v-model="dataItem[iKey].amount"
          placeholder="Miktar"
          type="number"
        />
      </b-input-group>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput, BInputGroup,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'PurchaseOfferItemAmount',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
    BInputGroup,
  },
  props: {
    iKey: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['purchaseOfferItems/dataList']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
